<template>
  <div class="admin">
    <div>
      <v-tabs v-model="tab">
        <v-tab
          v-for="i in items"
          :key="i.route"
          :to="i.route"
          style="text-transform: none; font-size: 12px"
        >
          {{ i.title }}
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: 0,
      items: [
        {
          title: "Dashboard",
          route: "/admin/dashboard",
          icon: "mdi-chart-line",
        },
        {
          title: "Users",
          route: "/admin/users",
          icon: "mdi-account-multiple",
        },
        {
          title: "Workspaces",
          route: "/admin/workspaces",
          icon: "mdi-domain",
        },
        {
          title: "Notifications",
          route: "/admin/notifications",
          icon: "mdi-bell",
        },

        {
          title: "Backlog",
          route: "/admin/backlog",
          icon: "mdi-list-box",
        },
        {
          title: "Emails",
          route: "/admin/emails",
          icon: "mdi-email",
        },
        {
          title: "Waiting List",
          route: "/admin/waiting-list",
          icon: "mdi-account-multiple",
        },
        {
          title: "Settings",
          route: "/admin/settings",
          icon: "mdi-cog",
        },
        {
          title: "Support",
          route: "/admin/support",
          icon: "mdi-headset",
        },
        // {
        //   title: "Subscriptions",
        //   route: "/admin/subscriptions",
        //   icon: "mdi-credit-card",
        // },
        // {
        //   title: "Invoices",
        //   route: "/admin/invoices",
        //   icon: "mdi-currency-eur",
        // },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
